import ReactDOM from 'react-dom/client'
import React from 'react'
import './styles.css'
import App from "./App";

// Create a root.
const root = ReactDOM.createRoot(document.getElementById('root'));

// Initial render.
root.render(<App />);